import { z } from 'zod'
import { decimalSchema, uuidSchema } from './common.ts'
import { warehouseUnitCodeSchema } from './units.ts'

export const warehouseQrLookupQuerySchema = z.object({
  code: z.string().trim().min(1).max(240),
})

export const warehouseQrBalanceSchema = z.object({
  locationId: uuidSchema,
  warehouseName: z.string(),
  locationName: z.string(),
  onHand: decimalSchema,
  reserved: decimalSchema,
  available: decimalSchema,
})

export const warehouseQrMaterialSchema = z.object({
  id: uuidSchema,
  name: z.string(),
  grade: z.string().nullable(),
  baseUnit: warehouseUnitCodeSchema,
  qrCode: z.string(),
  balances: z.array(warehouseQrBalanceSchema),
})

export type WarehouseQrMaterial = z.infer<typeof warehouseQrMaterialSchema>
